import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: 'learnData',
    name: 'LearnData',
    component: () => import('@/views/learnData/index.vue')
  },
  {
    path: 'learnData/learnData-all',
    name: 'LearnDataAll',
    component: () => import('@/views/learnData/components/allCalendar.vue')
  }
]

export default routes
